<template>
  <sistema>
    <div>
      <crud-rntrc-solicitacao :idRntrcSolicitacao="idRntrcSolicitacao" />
    </div>
  </sistema>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CrudRntrcSolicitacao from "../../components/rntrc/CrudRntrcSolicitacao.vue";

@Options({
  props: {
    idRntrcSolicitacao: Number
  },
  components: {
    CrudRntrcSolicitacao
  }
})
export default class RntrcSolicitacao extends Vue {
  idRntrcSolicitacao?: number;
}
</script>

<style scoped lang="scss"></style>
